import { type VehicleRoute, type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';
import type { PageableContent } from '@cobliteam/common-types';
import type { RouteHistoryAction } from './actions';
import { ActionTypes } from './actionTypes';

export interface RouteHistoryState {
  vehicleRoutesWebData: WebData<PageableContent<VehicleRoute>>;
}

export const routeHistoryInitialState: RouteHistoryState = {
  vehicleRoutesWebData: webDataNotAsked(),
};

export default (state: RouteHistoryState = routeHistoryInitialState, action: RouteHistoryAction): RouteHistoryState => {
  switch (action.type) {
    case ActionTypes.LOAD_VEHICLE_ROUTES_REQUEST:
      return { ...state, vehicleRoutesWebData: webDataFetching() };

    case ActionTypes.LOAD_VEHICLE_ROUTES_SUCCEEDED:
      return {
        ...state,
        vehicleRoutesWebData: webDataSuccess(action.payload),
      };

    case ActionTypes.LOAD_VEHICLE_ROUTES_FAILED:
      return { ...state, vehicleRoutesWebData: webDataError() };

    default:
      return state;
  }
};
